export default function genArrayField(itemHandler) {
  return {
    serialize(items, params) {
      return items.map(item => itemHandler.serialize(item, params));
    },
    deserialize(buffers, params) {
      return buffers.map(buffer => itemHandler.deserialize(buffer, params));
    }
  };
}
//# sourceMappingURL=array.mjs.map